<template>
    <div
        class="loading_view d-flex justify-center justify-center align-center"
        :style="{ position: absolute ? 'absolute' : 'relative' }"
    >
        <v-progress-circular indeterminate color="primary" width="1" :size="size"
            ><div class="px-6 text-center">
                {{ displayLabel ? label || $translate("loading") : "" }}
            </div></v-progress-circular
        >
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        label: {
            type: String,
            required: false,
        },
        displayLabel: {
            type: Boolean,
            default: true,
        },
        absolute: {
            type: Boolean,
            default: true,
        },
        size: {
            type: Number,
            default: 150,
        },
    },
    i18n: {
        messages: {
            en: {
                loading: "Loading...",
            },
            fr: {
                loading: "Chargement...",
            },
        },
    },
};
</script>

<style lang="scss">
.loading_view {
    font-size: 10pt;
    min-height: 100px;
    padding: 50px;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
}
</style>
